let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hhss7"), load("a6uKK")]).then(() => parcelRequire('ic1wA'));